/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout, Card, TextStyle, Icon } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import {
  ChatMajor,
  QuestionMarkMajor,
  SendMajor,
  PlayCircleMajor,
  CalendarMajor
} from '@shopify/polaris-icons';
import { URL } from 'src/constants/links';
import SendSupportTicket from './sendSupportTicket';
import ScheduleDemo from 'src/components/views/common/scheduleDemo';

type State = {
  hover: Array<boolean>,
  activeSendRequestModal: boolean,
  activeScheduleDemoModal: boolean
};

type MenuType = {
  title: string,
  content: string,
  src: string,
  href?: string,
  action?: (event: Event) => void
};

type Props = { planProducts: number } & WithI18nProps;
class HelpCenter extends Component<Props, State> {
  state = {
    hover: [false, false, false, false, false], // Event mouse for menu items,
    activeSendRequestModal: false,
    activeScheduleDemoModal: false
  };

  // Event mouse enter for menu item
  onMouseEnter = menuIndex => {
    this.setState(({ hover }) => {
      hover[menuIndex] = true;
      return { hover };
    });
  };

  // Event mouse leave for menu item
  onMouseLeave = menuIndex => {
    this.setState(({ hover }) => {
      hover[menuIndex] = false;
      return { hover };
    });
  };

  toggleModal = fieldName => {
    const value = this.state[fieldName];
    this.setState({ [fieldName]: !value });
  };

  render() {
    const { activeSendRequestModal, activeScheduleDemoModal } = this.state;
    const { i18n, planProducts } = this.props;

    const menus: Array<Array<MenuType>> = [
      [
        {
          title: i18n.translate('AdminHTML.Dashboard.HelpCenter.helpCenter_Menu1_Title'),
          content: i18n.translate('AdminHTML.Dashboard.HelpCenter.helpCenter_Menu1_Content'),
          src: ChatMajor,
          action: event => {
            event.preventDefault();
            window.Beacon('open');
          }
        },
        {
          title: i18n.translate('AdminHTML.Dashboard.Common.sendASupportTicket'),
          content: i18n.translate('AdminHTML.Dashboard.HelpCenter.helpCenter_Menu3_Content'),
          src: SendMajor,
          action: event => {
            event.preventDefault();
            this.toggleModal('activeSendRequestModal');
          }
        }
      ],
      [
        {
          title: i18n.translate('AdminHTML.Dashboard.HelpCenter.helpCenter_Menu2_Title'),
          content: i18n.translate('AdminHTML.Dashboard.HelpCenter.helpCenter_Menu2_Content'),
          src: QuestionMarkMajor,
          action: event => {
            event.preventDefault();
            this.openLink('HelpCenter');
          }
        },
        {
          title: i18n.translate('AdminHTML.Dashboard.HelpCenter.youTubeChannel_Title'),
          content: i18n.translate('AdminHTML.Dashboard.HelpCenter.youTubeChannel_Content'),
          src: PlayCircleMajor,
          href: 'https://youtube.com'
        }
      ]
    ];

    // Only support for plan with product >= 2000
    // Hide temporary
    if (planProducts >= 2000 && false) {
      menus[0].push({
        title: i18n.translate('AdminHTML.Dashboard.HelpCenter.scheduleDemo_Title'),
        content: i18n.translate('AdminHTML.Dashboard.HelpCenter.scheduleDemo_Content'),
        src: CalendarMajor,
        action: event => {
          event.preventDefault();
          this.toggleModal('activeScheduleDemoModal');
        }
      });
    }

    return (
      <div className="BC-HelpCenter__Dashboard">
        <Card title={i18n.translate('AdminHTML.Dashboard.HelpCenter.helpCenter_CardTitle')}>
          <Card.Section>
            <Layout>
              {(() => {
                let index = -1;
                return menus.map((menu, menuIndex) => (
                  <Layout.Section secondary key={'menu-' + menuIndex}>
                    {menu.map((subMenu, subMenuIndex) => {
                      // Calculate menu index
                      index += 1;

                      const { href = '', action, src, title, content } = subMenu;

                      const titleProps = action
                        ? { href: href, onClick: action }
                        : { href: href, target: '_blank', rel: 'noopener noreferrer' };

                      return (
                        <a
                          className="BC-Link__Dashboard"
                          {...titleProps}
                          key={'subMenu-' + subMenuIndex}>
                          <div
                            className="menuBox"
                            onMouseEnter={this.onMouseEnter.bind(this, index)}
                            onMouseLeave={this.onMouseLeave.bind(this, index)}>
                            <div
                              className={
                                this.state.hover[index] ? 'Polaris-Card-Hover' : 'Polaris-Card'
                              }>
                              <div className="Polaris-Card__Section">
                                <div
                                  className={
                                    this.state.hover[index] ? 'menuIconImg hover' : 'menuIconImg'
                                  }>
                                  <Icon source={src} color="base" />
                                </div>
                                <div className="menuContent">
                                  <TextStyle variation="strong">{title}</TextStyle>
                                  <TextStyle variation="subdued">{content}</TextStyle>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      );
                    })}
                  </Layout.Section>
                ));
              })()}
              <SendSupportTicket
                activeSendRequestModal={activeSendRequestModal}
                handleChangeModal={() => this.toggleModal('activeSendRequestModal')}
              />
              <ScheduleDemo
                activeScheduleDemoModal={activeScheduleDemoModal}
                handleChangeModal={() => this.toggleModal('activeScheduleDemoModal')}
              />
            </Layout>
          </Card.Section>
        </Card>
      </div>
    );
  }

  // Open new page with link
  openLink = (id: string) => {
    const newUrl = URL[id];
    window.open(newUrl, '_blank');
  };
}

const mapStateToProps = (state, props) => {
  const planProducts = _.get(state.oauth, 'tenantApp.appParams.currentTotalProducts', 0);
  return {
    planProducts
  };
};

export default withI18n()(connect(mapStateToProps, {})(HelpCenter));
